// extracted by mini-css-extract-plugin
export var parallaxyLeft = "parallaxY-module--parallaxyLeft--NTG4E";
export var parallaxyRight = "parallaxY-module--parallaxyRight--iEfoT";
export var active = "parallaxY-module--active--iCq-F";